export enum RoleType {
  ADMIN = "ROLE_ADMIN",
  USER = "ROLE_USER",
  EDUCATOR = "ROLE_EDUCATOR",
}
